<template>
	<div class="dynamicManage">
		<div class="page-header">
			<span>照片管理</span>
		</div>

		<div class="mar-left">
			<div class="search-import-container">
				<div class="search-form">
					<el-form :inline="true">
						<el-form-item>
							<el-select v-model="statusSelect" placeholder="状态筛选">
								<el-option v-for="item in statusSelectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-select v-model="recommendSelect" placeholder="推荐筛选">
								<el-option v-for="item in recommendSelectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-select v-model="silentSelect" placeholder="沉默筛选">
								<el-option v-for="item in silentSelectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-input v-model="userId" placeholder="用户ID" clearable></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="search">搜索</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div class="import-btn-wrapper">
					<el-button type="primary" @click="importPhotos">导入图片</el-button>
				</div>
			</div>
		</div>

		<div class="com-list">
			<el-table :data="photoList" ref="multipleTable" border style="width: 100%">
				<el-table-column prop="id" label="ID" width="60"></el-table-column>
				<el-table-column label="图片" width="120">
					<template slot-scope="scope">
						<img :src="scope.row.img" width="100" height="100" @click="showImg(scope.row)" />
					</template>
				</el-table-column>
				<el-table-column label="用户信息" width="180" class-name="user-info-column">
					<template slot-scope="scope">
						<div class="user-info-content">
							<div>ID: {{scope.row.publishUid}}</div>
							<div>姓名: {{scope.row.userName}}</div>
							<div>校区: {{scope.row.schoolName}}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="heatValue" label="热度值" width="80"></el-table-column>
				<el-table-column prop="totalVotes" label="红人票总值" width="150"></el-table-column>
				<el-table-column prop="weekVotes" label="本周红人票" width="150"></el-table-column>
				<el-table-column label="推荐" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.recommend === 1">已推荐</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="沉默" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.silent === 1">已沉默</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="状态" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.status === 2">正常</span>
						<span v-else-if="scope.row.status === 1">审核中</span>
						<span v-else-if="scope.row.status === 3">审核拒绝</span>
					</template>
				</el-table-column>
				<el-table-column prop="publishAt" label="发布时间" width="180"></el-table-column>
				<el-table-column label="操作" min-width="180" class-name="operation-column">
					<template slot-scope="scope">
						<div class="operation-buttons">
							<div class="operation-row">
								<el-button type="text" v-if="scope.row.recommend === 0" @click="toggleRecommend(scope.row, 1)">推荐</el-button>
								<el-button type="text" v-else @click="toggleRecommend(scope.row, 0)">取消推荐</el-button>
								
								<el-button type="text" v-if="scope.row.silent === 0" @click="toggleSilent(scope.row, 1)">沉默</el-button>
								<el-button type="text" v-else @click="toggleSilent(scope.row, 0)">取消沉默</el-button>
								
								<el-button type="text" @click="deletePhoto(scope.row)">删除</el-button>
							</div>
							<div class="operation-row">
								<el-button type="text" @click="adjustRedStar(scope.row)">调整本周红人票</el-button>
							</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div class="pagination">
			<el-pagination 
				v-show="this.totalCount > 0" 
				layout="prev, pager, next" 
				:page-size="20"
				:current-page="pageNum" 
				:total="totalCount" 
				@current-change="handleCurrentChange">
			</el-pagination>
		</div>

		<!-- 图片预览弹框 -->
		<el-dialog title="图片预览" size="small" top="5%" v-model="imgDialogVisible" :modal-append-to-body="false">
			<div style="text-align:center;min-height: 600px;">
				<img :src="previewImgUrl" class="img">
			</div>
		</el-dialog>

		<!-- 调整本周红人票弹框 -->
		<el-dialog title="本周红人票调整" size="small" v-model="redStarDialogVisible" :modal-append-to-body="false" custom-class="vote-dialog">
			<div class="vote-adjust-box">
				<div class="vote-input-row">
					<el-select v-model="redStarForm.operationType" class="vote-select">
						<el-option :value="1" label="增加"></el-option>
						<el-option :value="2" label="减少"></el-option>
					</el-select>
					<el-input v-model.number="redStarForm.value" type="number" class="vote-input"></el-input>
					<span class="vote-label">票</span>
				</div>
				<div class="vote-divider"></div>
				<div class="vote-actions">
					<el-button class="cancel-btn" @click="redStarDialogVisible = false">取消</el-button>
					<el-button class="confirm-btn" type="success" @click="submitRedStarAdjustment">确认</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				statusSelectList: [
					{ label: "全部", value: "-1" },
					{ label: "正常", value: "2" },
					{ label: "审核中", value: "1" },
					{ label: "审核拒绝", value: "3" }
				],
				recommendSelectList: [
					{ label: "全部", value: "-1" },
					{ label: "已推荐", value: "1" },
					{ label: "未推荐", value: "0" }
				],
				silentSelectList: [
					{ label: "全部", value: "-1" },
					{ label: "已沉默", value: "1" },
					{ label: "未沉默", value: "0" }
				],
				statusSelect: '-1',
				recommendSelect: '-1',
				silentSelect: '-1',
				userId: '',
				photoList: [],
				totalCount: 0,
				pageNum: 1,
				imgDialogVisible: false,
				previewImgUrl: '',
				redStarDialogVisible: false,
				redStarForm: {
					operationType: 1,
					value: ''
				},
				currentRedStar: 0,
				currentPhotoId: null
			}
		},
		mounted() {
			this.getPhotoList();
		},
		methods: {
			// 获取照片列表
			getPhotoList(val) {
				if (!val) {
					this.pageNum = 1;
				}
				
				this.$http({
					method: 'POST',
					url: this.$util.domain + '/adminapi/redRank/list',
					body: JSON.stringify({
						pageSize: 20,
						pageNum: this.pageNum,
						status: this.statusSelect,
						recommend: this.recommendSelect,
						silent: this.silentSelect,
						uid: this.userId || 0
					})
				}).then(response => {
					if (response.data.error === 10000) {
						let data = response.data.data;
						this.photoList = data.content || [];
						this.totalCount = data.totalElements || 0;
						
						// 格式化发布时间并处理publishUid
						this.photoList.forEach(item => {
					
							if (item.publishAt) {
								let date = new Date(item.publishAt);
								item.publishAt = date.getFullYear() + '-' +
									String(date.getMonth() + 1).padStart(2, '0') + '-' +
									String(date.getDate()).padStart(2, '0') + ' ' +
									String(date.getHours()).padStart(2, '0') + ':' +
									String(date.getMinutes()).padStart(2, '0') + ':' +
									String(date.getSeconds()).padStart(2, '0');
							}
						});
					}
				})
			},
			
			// 搜索
			search() {
				// 如果用户输入了ID，优先搜索publishUid
				if (this.userId) {
					console.log('搜索用户ID:', this.userId);
				}
				this.getPhotoList();
			},
			
			// 导入照片
			importPhotos() {
                this.$util.refreshTo("/#/photo/photoImport");
			},
			
			// 显示图片预览
			showImg(row) {
				this.previewImgUrl = row.img;
				this.imgDialogVisible = true;
			},
			
			// 切换推荐状态
			toggleRecommend(row, status) {
				// 确认弹框标题和内容
				let title = status === 1 ? '是否确定推荐？' : '是否确认取消推荐？';
				
				this.$confirm(title, '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http({
						method: 'POST',
						url: this.$util.domain + '/adminapi/redRank/recommend',
						body: JSON.stringify({
							id: row.id,
							status: status
						})
					}).then(response => {
						if (response.data.error === 10000) {
							this.$message.success(status === 1 ? '推荐成功' : '取消推荐成功');
							this.getPhotoList(this.pageNum);
						} else {
							this.$message.error('操作失败');
						}
					})
				}).catch(() => {
					// 用户取消操作
				});
			},
			
			// 切换沉默状态
			toggleSilent(row, status) {
				// 确认弹框标题和内容
				let title = status === 1 ? '是否确定沉默？ 沉默后将不会推荐给用户' : '是否确定取消沉默？';
				
				this.$confirm(title, '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http({
						method: 'POST',
						url: this.$util.domain + '/adminapi/redRank/silent',
						body: JSON.stringify({
							id: row.id,
							status: status
						})
					}).then(response => {
						if (response.data.error === 10000) {
							this.$message.success(status === 1 ? '沉默成功' : '取消沉默成功');
							this.getPhotoList(this.pageNum);
						} else {
							this.$message.error('操作失败');
						}
					})
				}).catch(() => {
					// 用户取消操作
				});
			},
			
			// 打开调整红人票弹窗
			adjustRedStar(row) {
				this.currentRedStar = row.weekVotes;
				this.currentPhotoId = row.id;
				this.redStarForm = {
					operationType: 1,
					value: ''
				};
				this.redStarDialogVisible = true;
			},
			
			// 提交红人票调整
			submitRedStarAdjustment() {
				// 验证输入
				if (!this.redStarForm.value || this.redStarForm.value <= 0 || !/^\d{1,8}$/.test(this.redStarForm.value)) {
					this.$message.error('请输入大于0的整数（最多8位）');
					return;
				}
				
				// 计算最终票数
				let finalVotes = this.redStarForm.operationType === 1 ? 
					this.redStarForm.value : 
					-this.redStarForm.value;
				
				// 打印请求参数
				console.log('调整红人票请求参数:', {
					id: this.currentPhotoId,
					voteCount: finalVotes
				});
				
				this.$http({
					method: 'POST',
					url: this.$util.domain + '/adminapi/redRank/adjustVote',
					body: JSON.stringify({
						id: this.currentPhotoId,
						voteCount: finalVotes
					})
				}).then(response => {
					// 打印完整响应
					console.log('调整红人票响应:', response);
					
					if (response.data.error === 10000) {
						this.$message.success('调整成功');
						this.redStarDialogVisible = false;
						this.getPhotoList(this.pageNum);
					} else {
						// 打印错误信息
						console.error('调整红人票失败:', response.data.message || '未知错误');
						this.$message.error('操作失败: ' + (response.data.message || '未知错误'));
					}
				}).catch(error => {
					// 打印网络错误
					console.error('调整红人票网络错误:', error);
					this.$message.error('网络错误: ' + error.message);
				});
			},
			
			// 删除照片
			deletePhoto(row) {
				this.$confirm('确定要删除该照片吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http({
						method: 'POST',
						url: this.$util.domain + '/adminapi/redRank/delete',
						body: JSON.stringify({
							id: row.id
						})
					}).then(response => {
						if (response.data.error === 10000) {
							this.$message.success('删除成功');
							this.getPhotoList(this.pageNum);
						} else {
							this.$message.error('删除失败');
						}
					})
				}).catch(() => {});
			},
			
			// 切换页码
			handleCurrentChange(val) {
				this.pageNum = val;
				this.getPhotoList(val);
			}
		}
	}
</script>

<style scoped>
	/* 页面头部样式 */
	.page-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 20px;
		background-color: #f5f7fa;
		margin-bottom: 20px;
	}
	
	.page-header span {
		font-size: 18px;
		font-weight: bold;
	}

	.dynamicManage .el-select {
		display: inline-block;
	}

	.dynamicManage .el-input {
		display: inline-block;
	}

	.dynamicManage .el-button {
		display: inline-block;
	}

	.dynamicManage .el-button+.el-button {
		margin-left: 0;
	}

	.dynamicManage .mar-left {
		margin-left: 30px;
	}

	.dynamicManage .img {
		max-width: 100%;
		max-height: 600px;
	}

	/* 红人票调整弹窗样式 */
	.vote-adjust-box {
       
		text-align: center;
		padding: 20px 0;
	}
	
	.vote-input-row {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 20px;
	}
	
	.vote-select {
		width: 250px;
		margin-right: 20px;
	}
	
	.vote-input {
		width: 250px;
		margin-left: 10px;
		margin-right: 10px;
	}
	
	.vote-label {
		width: 100px;
	}
	
	.vote-divider {
		height: 1px;
		background-color: #dcdfe6;
		margin-bottom: 20px;
	}
	
	.vote-actions {
		margin-top: 10px;
	}
	
	.cancel-btn {
		background-color: #67c23a;
		border-color: #67c23a;
		color: #fff;
	}
	
	.confirm-btn {
		background-color: #67c23a;
		border-color: #67c23a;
		color: #fff;
	}

	/* 表格样式优化 */
	.com-list .el-table {
		width: 100%;
	}
	
	.com-list .el-table .cell {
		white-space: nowrap;
		text-align: center;
	}
	
	/* 用户信息列居中对齐 */
	.com-list .el-table .user-info-column .cell {
		text-align: center;
	}
	
	/* 用户信息内容样式 */
	.user-info-content {
		display: inline-block;
		text-align: left;
	}
	
	/* 操作列居中对齐 */
	.com-list .el-table .operation-column .cell {
		text-align: center;
	}
	
	/* 操作按钮样式 */
	.operation-buttons {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	
	.operation-row {
		display: flex;
		justify-content: center;
		margin-bottom: 5px;
		width: 100%;
		min-width: 180px;
	}
	
	.operation-row .el-button {
		margin: 2px 5px;
		white-space: nowrap;
	}
	
	/* 调整本周红人票按钮样式 */
	.operation-row:last-child .el-button {
		width: auto;
		text-align: center;
	}

	/* 搜索和导入按钮容器 */
	.search-import-container {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
	}
	
	.search-form {
		flex: 1;
	}
	
	.import-btn-wrapper {
		padding-right: 20px; /* 这里控制右边距 */
	}
</style>


// WEBPACK FOOTER //
// photoList.vue?e47f5952